import { IPairedDonor } from '@nkr/store/index';

interface IState {
    hashValue: string,
    hash: string,
    data: IPairedDonor[],
}

const initialState: IState = {
    hashValue: '',
    hash: '',
    data: [],
};

const pairedDonorsReducer = (state: IState, action: { type: string, value: any }): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.value.data,
            hash: action.value.hash,
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.value };
    }

    return { ...state };
};

export {
    IState, initialState,
    pairedDonorsReducer
};